export default __webpack_public_path__ + "static/media/paypal.35fa3c62.png";